// extracted by mini-css-extract-plugin
export default {"item":"order-card-ingredient_item__W0Omc","cropper":"order-card-ingredient_cropper__ixqxB","image":"order-card-ingredient_image__6RrrN","count":"order-card-ingredient_count__yifzQ"};